import Home from 'components/page-builder/home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { setCurrentWidth, LoadingPage } from 'shared-components';
import { Suspense, lazy } from 'react';
import { PuckWrapper } from './PuckWrapper';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { useEffect } from 'react';
import PageNotFound from 'components/NotFoundPage';
import Funnelish from 'components/page-builder/funnelish';

export const CheckoutRouter = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const handleResize = () => {
      dispatch(setCurrentWidth(window?.innerWidth));
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window?.innerWidth]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PuckWrapper />}>
          <Route path={'/'} element={<Home />} />
          <Route
            path="/post-upsell"
            element={
              <Suspense fallback={<LoadingPage />}>
                <LazyPostUpsellPage
                  useAppDispatch={useAppDispatch}
                  useAppSelector={useAppSelector}
                />
              </Suspense>
            }
          />
          <Route path="/funnelish" element={<Funnelish />} />
          <Route path="/*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

const LazyPostUpsellPage = lazy(async () => {
  const PostUpsellPage = await import(
    'shared-components/src/page-builder/components/post-upsell-pages'
  );
  return { default: PostUpsellPage.default };
});
